import React from 'react';

const About = () => (
  <div>
    <h1>
      Work in Progress
    </h1>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/App/About/index.js